module.exports = __webpack_public_path__ + "static/step2_mission_boy-cac360994c2e732ce8dd63a72ee86ff7.svg";